var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "section",
        {
          staticClass: "content-bar d-flex bg-black justify-content-center",
          attrs: { id: "comment-bar" }
        },
        [_c("ncc-content-column", { attrs: { html: _vm.comment } })],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }